import { useQuery } from '@tanstack/vue-query'
import { getAllInventoryTypes } from '../inventory-types'
import { AxiosError } from 'axios'

export function useInventoryTypesQuery() {
  return useQuery({
    queryKey: ['inventory-types'],
    queryFn: ({ signal }) => getAllInventoryTypes(signal),
    staleTime: 30 * 60 * 1000, // 30 minutes
    cacheTime: 60 * 60 * 1000, // 1 hour
    retry: (failureCount, error: AxiosError) =>
      failureCount < 3 && error.status !== undefined && error.status >= 500,
  })
}
